import type { CSSProperties, ReactNode } from 'react';

import styles from './BlurAnimation.module.css';

/**
 * Перенос `lib/src/presentation/widgets/blur_animation.dart`.
 *
 * Отличие от Flutter: `ImageFiltered` ничего не меняет в раскладке, а здесь
 * появляется <div>. Через `className` его можно вписать в разметку вызова.
 */

/** `BlurEffect(begin: Offset(0, 0), end: Offset(10, 10))` */
const BLUR_RADIUS_PX = 10;

/** `duration = const Duration(milliseconds: 200)` */
const DEFAULT_DURATION_MS = 200;

export interface BlurAnimationProps {
  readonly animate: boolean;
  /** Длительность перехода, мс. */
  readonly duration?: number;
  readonly className?: string;
  readonly children: ReactNode;
}

export function BlurAnimation({
  animate,
  duration = DEFAULT_DURATION_MS,
  className,
  children,
}: BlurAnimationProps) {
  const style = {
    '--blur-radius': `${animate ? BLUR_RADIUS_PX : 0}px`,
    '--blur-duration': `${duration}ms`,
  } as CSSProperties;
  return (
    <div className={`${styles.blur} ${className ?? ''}`} style={style}>
      {children}
    </div>
  );
}
